import {TableSummary} from "../../../../../domain/out/table-summary";
import {CustomGroup} from "../../../../../domain/in/quote/group/custom-group";
import {FrCaIcsVtSasSynthesisMapper} from "./sas/fr.ca-ics-vt.sas.synthesis.mapper";
import {
    ContractViewSynthesisReorganizationService
} from "../../contract-view-synthesis-reorganization/contract-view-synthesis-reorganization.service";
import {PricingItem} from "../../../../../domain/in/quote/pricing-item/pricing-item";
import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {FrCaIcsVtVtSynthesisMapper} from "./vt/fr.ca-ics-vt.vt.synthesis.mapper";
import {FrCaIcsVtLsSynthesisMapper} from "./ls/fr.ca-ics-vt.ls.synthesis.mapper";
import {EnumPricingItemType} from "../../../../../domain/in/quote/pricing-item/pricing-item-type";
import {OptionPricingItem} from "../../../../../domain/in/quote/pricing-item/option-pricing-item";
import {getOptionsSummary} from "../../option-summary.util";


export class TableSummaryCaIcsVtMapper {
    private caIcsVtSasSynthesisMapper: FrCaIcsVtSasSynthesisMapper;
    private caIcsVtVtSynthesisMapper: FrCaIcsVtVtSynthesisMapper;
    private caIcsVtLsSynthesisMapper : FrCaIcsVtLsSynthesisMapper;
    private contractViewSynthesisReorganizationService: ContractViewSynthesisReorganizationService;

    constructor(protected translationService: TranslationServiceInterface
    ) {
        this.caIcsVtSasSynthesisMapper = new FrCaIcsVtSasSynthesisMapper(translationService);
        this.caIcsVtVtSynthesisMapper = new FrCaIcsVtVtSynthesisMapper(translationService);
        this.caIcsVtLsSynthesisMapper = new FrCaIcsVtLsSynthesisMapper(translationService);
        this.contractViewSynthesisReorganizationService = new ContractViewSynthesisReorganizationService();
    }

    public async getTablesSummary(group: CustomGroup, serviceCode: string, currency: string, view: string, locale: string): Promise<TableSummary[]> {
        let tableSummaries: TableSummary[] = [];

        if (view === 'contract') {
            let specialPricingItemsCategories = this.contractViewSynthesisReorganizationService.getSpecialPricingItemsCategories(group.pricingItems);
            for (const [subFamily, pricingItems] of Array.from(specialPricingItemsCategories.entries())) {
                tableSummaries.push(await this.createTable(serviceCode, pricingItems, currency, subFamily, locale));
            }
        } else {
            tableSummaries.push(await this.createTable(serviceCode, group.pricingItems, currency, '', locale));
        }

        return tableSummaries;
    }

    private async createTable(serviceCode: string, pricingItems: PricingItem[], currency: string, subFamily: string, locale: string): Promise<TableSummary> {
        let tableSummary = new TableSummary();

        switch (serviceCode) {
            case 'SAS':
                tableSummary.subFamily = subFamily;
                tableSummary.pricingItems = await Promise.all(pricingItems.map(pricingItem => {
                    return this.caIcsVtSasSynthesisMapper.pricingItemToProductItemSummary(pricingItem, currency, locale);
                }));
                if (subFamily === 'OTHER') {
                    tableSummary.labels = [await this.translationService.translate("OTHER", locale),
                        await this.translationService.translate("SYNTHESIS.LABEL_RECHARGE_BOBINES", locale),
                        await this.translationService.translate("SYNTHESIS.LABEL_PU_HT_RECH_SUPP", locale)];
                } else {
                    tableSummary.labels = [await this.translationService.translate("SYNTHESIS.LABEL_CATEGORY_TABLE_" + subFamily.toUpperCase(), locale),
                        await this.translationService.translate("SYNTHESIS.LABEL_RECHARGE_" + subFamily.toUpperCase(), locale),
                        await this.translationService.translate("SYNTHESIS.LABEL_PU_HT_EXTRA_" + subFamily.toUpperCase(), locale)];
                }


                return tableSummary;
            case 'VT': {
                const productPricingItems = pricingItems.filter(item => item.pricingItemType !== EnumPricingItemType.OPTION);
                const productSummaries = await Promise.all(productPricingItems.map(pricingItem => {
                    return this.caIcsVtVtSynthesisMapper.pricingItemToProductItemSummary(pricingItem, currency, locale);
                }));

                const options = pricingItems
                    .filter((item): item is OptionPricingItem => item.pricingItemType === EnumPricingItemType.OPTION)
                    .map(item => item.option);
                const optionSummaries = options.length ? getOptionsSummary(options, currency, locale) : [];

                tableSummary.pricingItems = [...productSummaries, ...optionSummaries];
                return tableSummary;
            }
            case 'LS':
                tableSummary.pricingItems = await Promise.all(pricingItems.map(pricingItem => {
                    return this.caIcsVtLsSynthesisMapper.pricingItemToProductItemSummary(pricingItem, currency, locale);
                }));
                return tableSummary;
            default:
                break;
        }
    }

}
